// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Remove the outline from the Google Maps popover buttons
 */
html body .placemakr-ibe button.gm-ui-hover-effect {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/googlemaps.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,aAAa;AACf","sourcesContent":["/**\n * Remove the outline from the Google Maps popover buttons\n */\nbutton.gm-ui-hover-effect {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
